import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UsersService } from '../service/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private app: UsersService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
     if (this.app.isLoggedIn()) {
      //  console.log(`auth Guard`, this.app.isLoggedIn())
     const pwd = localStorage.getItem(`pwdresetflags`);
     if(pwd === 'N') {
      this.router.navigate(['/layout/dashboard']);
      return false;
     } else {
      localStorage.clear();
     }
     }
    //  console.log(`else Guard1`, this.app.isLoggedIn())
     return true;
  }
}
